import React from 'react';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { OfferCard } from './OfferCard';
import { bonuses } from '../data/offer';
export function Bonuses() {
  return <section className="relative w-full overflow-hidden bg-ink-950 py-20" aria-labelledby="bonos" data-id="element-13" data-mp="au1uenirogiw">
      <div className="grid-bg pointer-events-none absolute inset-0 opacity-40" aria-hidden="true" data-id="element-14" data-mp="fsv6cbienzgy" />
      <div className="relative mx-auto max-w-5xl px-5" data-id="element-15" data-mp="1tlpraqaf3cg">
        <SectionHeading eyebrow="Si entras hoy" title={<span id="bonos" className="inline-flex flex-wrap items-center justify-center gap-3" data-id="element-17" data-mp="5tnn57ozpalx">
              <GiftIcon className="h-8 w-8 text-brand-red" aria-hidden="true" data-id="element-18" data-mp="3o3y5xt96h484" />3 bonos que no se
              venden por separado
            </span>} subtitle="El acompañamiento es lo que hace la diferencia entre comprar un curso y terminar el plan." data-id="element-16" data-mp="5vqnakjuwk4d" />

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-19" data-mp="1r8jtp3zkn0ia">
          {bonuses.map((item, index) => <OfferCard key={item.id} item={item} index={index} data-id="element-20" data-mp="3ic3i65mj8udr" data-mpi={index} />)}
        </div>
      </div>
    </section>;
}